// Frontend mirror of app/utils/budget_overrides.py so each campaign×day cell
// resolves without a round-trip (and edits preview optimistically). ISO date
// strings compare lexicographically, so window checks are plain string compares;
// overlaps resolve to the highest id (auto-increment ⇒ latest created).

export function effectiveBudget(dayIso, base, overrides) {
  const covering = (overrides || []).filter(
    (o) => o.from_date <= dayIso && dayIso <= o.to_date
  );
  if (covering.length === 0) {
    return { amount: base ?? null, overrideId: null };
  }
  const winner = covering.reduce((a, b) => ((b.id ?? 0) >= (a.id ?? 0) ? b : a));
  return { amount: winner.amount, overrideId: winner.id };
}

// The single-day override a cell "owns" — the one an inline edit can replace or
// clear without affecting other days. Multi-day promos are managed separately.
export function cellOverride(dayIso, overrides) {
  return (
    (overrides || []).find((o) => o.from_date === dayIso && o.to_date === dayIso) || null
  );
}
